import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
  inject
} from '@angular/core';

import { InvestmentLocationData } from '@features/investment/utils/investment-location.utils';
import { InvestmentLocationInputModalComponent } from '@features/investment/components/investment-location-input-modal.component';
import { FormWizardEnhancedComponent } from '@shared/components/form/form-wizard/form-wizard.component';
import { INVESTMENT_FORM_WIZARD_PROVIDERS } from '@features/investment/components/investment-form-wizard.providers';
import { FlowPageLayoutComponent } from '@shared/components/layout/flow-page-layout/flow-page-layout.component';
import { FormPageShellComponent } from '@shared/components/layout/form-page-shell/form-page-shell.component';
import { PageHeaderComponent } from '@shared/components/layout/page-header/page-header.component';

import { InvestmentCreateFacade } from './investment-create.facade';

@Component({
  selector: 'app-investment-create',
  standalone: true,
  imports: [
    FormWizardEnhancedComponent,
    PageHeaderComponent,
    FlowPageLayoutComponent,
    FormPageShellComponent,
    InvestmentLocationInputModalComponent,
  ],
  providers: [InvestmentCreateFacade, ...INVESTMENT_FORM_WIZARD_PROVIDERS],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: block; height: 100%;' },
  templateUrl: './investment-create.component.html',
  styleUrls: ['./investment-create.component.scss']
})
export class InvestmentCreateComponent implements OnInit, AfterViewInit {
  readonly facade = inject(InvestmentCreateFacade);

  @ViewChild('formWizard') formWizard?: FormWizardEnhancedComponent;

  readonly isLoading = this.facade.isLoading;
  readonly headerConfig = this.facade.headerConfig;
  readonly formConfig = this.facade.formConfig;
  readonly initialData = this.facade.initialData;

  ngOnInit(): void {
    this.facade.init();
  }

  ngAfterViewInit(): void {
    this.facade.bindForm(this.formWizard?.form);
  }

  onFormChange(_data: unknown): void {
    this.facade.bindForm(this.formWizard?.form);
  }

  onCancel(): void {
    this.facade.cancel();
  }

  onLocationSave(data: InvestmentLocationData): void {
    void this.facade.saveLocation(data);
  }
}
